(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-blog-filter-grid]').forEach((grid) => {
      if (grid.dataset.blogFilterReady) return;
      grid.dataset.blogFilterReady = 'true';
      const root = grid.closest('.ah-blog');
      const form = root.querySelector('[data-blog-filter-form]');
      const input = root.querySelector('[data-blog-filter-input]');
      const queryFromUrl = new URLSearchParams(location.search).get('q');
      if (queryFromUrl && !input.value) input.value = queryFromUrl;
      const status = root.querySelector('[data-blog-filter-status]');
      const featured = root.querySelector('.ah-blog__featured');
      const pagination = root.querySelector('[data-blog-filter-pagination]');
      const initialCards = Array.from(grid.querySelectorAll('.ah-blog__card'));
      const pages = Number(grid.dataset.blogPages) || 1;
      const currentPage = Number(grid.dataset.blogCurrent) || 1;
      const posts = Number(grid.dataset.blogPosts) || 12;
      const items = new Map();
      let loading = false;
      let loaded = false;
      let failed = false;
      let timer;
      const add = (card, order) => {
        const link = card.querySelector('h3 a');
        if (!link) return;
        const key = new URL(link.href, location.href).pathname;
        if (!items.has(key)) items.set(key, {card, order, text: card.textContent.toLocaleLowerCase()});
      };
      initialCards.forEach((card, index) => add(card, (currentPage - 1) * posts + index + (currentPage === 1 && featured ? 1 : 0)));
      const featuredTemplate = root.querySelector('.ah-blog__featured-search-card');
      if (featuredTemplate) add(featuredTemplate.content.firstElementChild.cloneNode(true), 0);
      const render = () => {
        const query = input.value.trim().toLocaleLowerCase();
        if (!query) {
          grid.replaceChildren(...initialCards);
          if (featured) featured.hidden = false;
          if (pagination) pagination.hidden = false;
          status.hidden = true;
          return;
        }
        if (featured) featured.hidden = true;
        if (pagination) pagination.hidden = true;
        const matches = Array.from(items.values()).filter((item) => item.text.includes(query)).sort((a,b) => a.order - b.order);
        grid.replaceChildren(...matches.map((item) => item.card));
        status.hidden = false;
        if (loading) status.textContent = grid.dataset.blogLoading;
        else if (failed) status.textContent = grid.dataset.blogError;
        else if (matches.length === 0) status.textContent = grid.dataset.blogEmpty;
        else status.textContent = matches.length + ' ' + grid.dataset.blogResults;
      };
      const loadPages = async () => {
        if (loaded || loading) return;
        loading = true;
        render();
        for (let page = 1; page <= pages; page += 1) {
          if (page === currentPage) continue;
          try {
            const url = new URL(grid.dataset.blogUrl, location.origin);
            url.searchParams.set('page', String(page));
            const response = await fetch(url, {credentials: 'same-origin'});
            if (!response.ok) throw new Error('Blog page could not be loaded');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const fetchedGrid = html.querySelector('[data-blog-filter-grid]');
            if (!fetchedGrid) throw new Error('Blog articles could not be found');
            const fetchedFeature = html.querySelector('.ah-blog__featured-search-card');
            if (fetchedFeature) add(fetchedFeature.content.firstElementChild.cloneNode(true), 0);
            fetchedGrid.querySelectorAll('.ah-blog__card').forEach((card, index) => add(card, (page - 1) * posts + index + (page === 1 && fetchedFeature ? 1 : 0)));
            render();
          } catch (error) {
            failed = true;
          }
        }
        loading = false;
        loaded = true;
        render();
      };
      const search = () => {
        render();
        if (input.value.trim()) loadPages();
      };
      form.addEventListener('submit', (event) => { event.preventDefault(); search(); });
      input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(search, 180); });
      root.querySelectorAll('[data-blog-topic-query]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          input.value = link.dataset.blogTopicQuery;
          input.focus();
          search();
        });
      });
      if (input.value.trim()) search();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

